//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'serum',
  data() {
    return {
      form: {
        item1: '',
        item2: ''
      },
      res: '',
      hasScore: false,
      disabled: false,
      text: ''
    }
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        self.res = form.item2 - form.item1
        self.res = self.res.toFixed(1)
        if (self.res >= 1.1) {
          self.text = '门静脉高压可能'
        }
        if (self.res < 1.1) {
          self.text = '不考虑门静脉高压'
        }
        self.hasScore = true
        return String(self.res,)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/serum.vue